import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { fetchCorpOptions, type CorpOptionItem } from "@app/api/corp";

export interface CorpSelectOption {
    label: string;
    value: string;
    [key: string]: unknown;
}

/** 管理端企业下拉（会话内缓存，登录后或列表刷新时拉取） */
export const useCorpOptionsStore = defineStore("corpOptions", () => {
    const items = ref<CorpOptionItem[]>([]);
    const loaded = ref(false);
    const loading = ref(false);

    const selectOptions = computed<CorpSelectOption[]>(() =>
        items.value.map(item => ({
            label: item.corpName,
            value: item.id,
        })),
    );

    async function fetchOptions(force = false) {
        if (loading.value) return;
        if (loaded.value && !force) return;

        loading.value = true;
        try {
            const data = await fetchCorpOptions({ cooperationStatus: 1 });
            items.value = data.items ?? [];
            loaded.value = true;
        } catch (e) {
            console.error("[corpOptions]", e);
            if (force) items.value = [];
        } finally {
            loading.value = false;
        }
    }

    function fetchIfNeeded() {
        return fetchOptions(false);
    }

    function refresh() {
        return fetchOptions(true);
    }

    function reset() {
        items.value = [];
        loaded.value = false;
        loading.value = false;
    }

    return { items, loaded, loading, selectOptions, fetchIfNeeded, refresh, reset };
});
